export const CHANGE_TASK_RESOURCE_USER_ALLOCATION_MODE = {
  ALLOCATE_WHAT_FITS: 'ALLOCATE_WHAT_FITS',
  ALLOCATE_FULL_AMOUNT: 'ALLOCATE_FULL_AMOUNT',
  REMOVE_ALLOCATION: 'REMOVE_ALLOCATION'
};
